import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'

const THead = React.forwardRef(({children, asElement: Component = 'thead', className, ...rest}, ref) => {
    const tHeadClass = classNames(Component !== 'thead' && 'thead', className)

    return (
        <Component className={tHeadClass} {...rest} ref={ref}>
            {children}
        </Component>
    )
})

THead.propTypes = {
    asElement: PropTypes.string,
}

export default THead
